<ng-template #cardTemplate>
  @for (option of items | async; track option) {
    <eas-booking-item-option-slot
    [bookingItemOption]="option.orig"></eas-booking-item-option-slot>
  }
</ng-template>

@if (items) {
  <app-list title="Available bookings" i18n-title
    [subtitle]="subtitle"
    [cardTemplate]="cardTemplate"
    [actions]="path.length > 0 ? actions : []"
    >
  </app-list>
}
